import React, { useEffect, useState, useMemo } from "react";
import { TabPanel, TabContext } from "@mui/lab";
import {
  Button,
  Avatar,
  Grid,
  Tab,
  Tabs,
  Typography,
  Box,
} from "@mui/material";
import { getUser } from "../api/users";
import UpdateProfileModal from "./component/UpdateProfileModal";
import { ContentContainer } from "../layout/ContentContainer";
import PrintTeeModal from "./component/PrintTeeModal";
// import { UseUserDocContext } from "../context/UserDocProvider";
import {
  getDoc,
  updateDoc,
  doc,
  getDocs,
  collection,
} from "firebase/firestore";
import ClaimsCard from "./component/ClaimsCard";
import { useAuthContext } from "../context/AuthContextProvider";
import { firestore } from "../firebase";
import { useNavigate } from "react-router-dom";
import { OrdersCard } from "./component/OrdersCard";
import { useWeb3Context } from "../context/UseWeb3Context";

const ProfilePage = ({ title, username, description, joinedDate }) => {
  const { authToken, bigBeyondContract } = useAuthContext();
  const { account, library } = useWeb3Context();
  const [value, setValue] = useState("0");
  const [currentUser, setCurrentUser] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [printTeeModal, setPrintTeeModal] = useState(false);
  const [paymentData, setPaymentData] = useState();
  // const { docData } = UseUserDocContext();
  const [docData, setDocData] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    const getDocData = async () => {
      const docToProcess = await doc(firestore, "users", account);
      setDocData(docToProcess);
    };
    if (!(account === undefined)) {
      getDocData();
    }
  }, [account]);
  const [mintState, setMintState] = useState([]);
  const [supply, setSupply] = useState();
  const [mintClaim, setMintClaim] = useState({});
  const [claimedtoken, setClaimedtoken] = useState([]);

  const contract = useMemo(
    () => bigBeyondContract(library, account),
    [bigBeyondContract, library, account]
  );

  useEffect(() => {
    !authToken && navigate("/drop");
  }, []);

  useEffect(() => {
    const getNftData = async () => {
      try {
        let mintData;
        const data = await getDoc(docData);
        mintData = data.data().mintData;

        const updateData = [];
        for (let i = 0; i < mintData.length; i++) {
          if (!mintData[i].tokenID) {
            const data = await library.getTransactionReceipt(
              mintData[i].hashCode
            );

            if (data?.logs && data?.logs.length) {
              const tokenData = data?.logs.map((item) => {
                return Number(item.topics[3]);
              });

              updateData.push({
                ...mintData[i],
                tokenID: tokenData,
              });
            } else {
              updateData.push(mintData[i]);
            }
          } else {
            updateData.push(mintData[i]);
          }
        }

        updateDoc(docData, {
          mintData: updateData,
        })
          .then(() => {
            // console.log("updated");
            setMintState(updateData);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        console.log(err);
      }
    };
    if (docData) {
      getNftData();
    }
  }, [docData, library]);

  useEffect(() => {
    const getSupplyData = async () => {
      try {
        const mxs = await contract.maxSupply();
        setSupply(mxs.toNumber());
        // alert("compe");
      } catch (err) {
        console.log(err);
      }
    };
    contract && getSupplyData();
  }, [contract]);

  useEffect(() => {
    if (account) {
      getUser(account).then((res) => {
        setCurrentUser(res);
        setClaimedtoken(
          res?.printTee &&
            res?.printTee.map((d) => {
              return d.mintDataToken;
            })
        );
      });
      const getPaymentData = async () => {
        try {
          const payData = [];
          const paymentData = await getDocs(collection(firestore, "payments"));
          paymentData.forEach((e) => {
            payData.push({ ...e.data(), id: e.id });
          });

          setPaymentData(payData);
        } catch (err) {
          console.log({ err });
        }
      };
      getPaymentData();
    }
  }, [account, printTeeModal]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const openEditModal = () => {
    setOpenModal(true);
  };

  const closeEditModal = () => {
    setOpenModal(false);
  };

  const avatarText =
    (currentUser?.fullname && String(currentUser?.fullname).charAt(0)) || "";
  return (
    <>
      {openModal && (
        <UpdateProfileModal openModal={openModal} closeModal={closeEditModal} />
      )}
      {printTeeModal && (
        <PrintTeeModal
          openModal={printTeeModal}
          closeModal={() => setPrintTeeModal(false)}
          //  mintDataIndex=
          mintDataToken={mintClaim?.token}
          mintHashCode={mintClaim?.hashcode}
        />
      )}
      <Box
        sx={{
          border: "0px solid black",
          height: "200px",
          background: "#C4C4C4",
        }}
      />

      <Box
        sx={{
          border: "0px solid black",
          height: "200px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Grid container>
          <Grid item xs={12} align="center">
            <Box sx={{ marginTop: "-60px" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <Avatar
                  alt=""
                  src="/"
                  sx={{ width: 150, height: 150, bgcolor: "#CE5858" }}
                >
                  {avatarText}
                </Avatar>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: { md: "25px", xs: "15px" },
                  }}
                >
                  {currentUser.firebaseId}
                </Typography>
                <Typography sx={{ fontWeight: "bold", fontSize: "25px" }}>
                  {currentUser.fullname ? currentUser.fullname : null}
                </Typography>

                {currentUser?.joinedDate && (
                  <Typography sx={{ fontWeight: "bold", fontSize: "25px" }}>
                    {currentUser.joinedDate}
                  </Typography>
                )}
              </Box>
              {account && (
                <Box textAlign="right">
                  <Button
                    variant="contained"
                    sx={{
                      position: "relative",
                      marginTop: "-250px",
                      marginRight: { md: "50px", xs: "" },
                    }}
                    onClick={openEditModal}
                  >
                    Edit Profile
                  </Button>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>

      <ContentContainer>
        <Box sx={{ width: "100%", typography: "body1", marginTop: "40px" }}>
          <TabContext value={value}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <Tabs
                variant="fullWidth"
                value={value}
                onChange={handleChange}
                aria-label="orders-claims-tabs"
              >
                <Tab
                  sx={{
                    fontSize: "120%",
                    fontWeight: "bold",
                    minWidth: { md: "385px" },
                  }}
                  label="Orders"
                  value="0"
                />
                <Tab
                  sx={{
                    fontSize: "120%",
                    fontWeight: "bold",
                    minWidth: { md: "385px" },
                  }}
                  label="Claims"
                  value="1"
                />
              </Tabs>
            </Box>

            <TabPanel value="0" index={0}>
              <Box sx={{ width: { md: "770px" }, marginLeft: { md: "-25px" } }}>
                <Grid container spacing={2} column={12}>
                  {currentUser?.orders?.map((e, i) => {
                    if (!e.mintForMe) {
                      if (
                        paymentData?.some(
                          (data) =>
                            data.id === e.paymentIntentId &&
                            data.status === "succeeded"
                        )
                      ) {
                        return (
                          <OrdersCard
                            key={i}
                            order={e}
                            docData={docData}
                            currentUser={currentUser}
                          />
                        );
                      }
                    }
                  })}
                </Grid>
              </Box>
            </TabPanel>
            <TabPanel value="1" index={1}>
              <Box sx={{ width: { md: "770px" }, marginLeft: { md: "-25px" } }}>
                {supply && (
                  <Grid container spacing={2} column={12}>
                    {(mintState ? mintState : currentUser?.mintData).map(
                      (e, i) => (
                        <>
                          {e?.tokenID?.map((d, j) => {
                            return (
                              <ClaimsCard
                                token={d}
                                key={j}
                                mintData={e}
                                claimedtoken={claimedtoken}
                                setPrintTeeModal={setPrintTeeModal}
                                supply={supply}
                                setMintClaim={setMintClaim}
                              />
                            );
                          })}
                        </>
                      )
                    )}
                    {currentUser?.orders?.map((e, i) => {
                      if (e.mintForMe) {
                        if (
                          paymentData?.some(
                            (data) =>
                              data.id === e.paymentIntentId &&
                              data.status === "succeeded"
                          )
                        ) {
                          return (
                            <OrdersCard
                              key={i}
                              order={e}
                              docData={docData}
                              currentUser={currentUser}
                            />
                          );
                        }
                      }
                    })}
                  </Grid>
                )}
              </Box>
            </TabPanel>

            {/* <TabPanel value="0" index={0}>
              <Grid container spacing={2} column={12}>
                {currentUser?.orders?.map((order, index) => {
                  return (
                    <React.Fragment key={index}>
                      {order.status === "succeeded" && (
                        <Grid
                          item
                          xs={12}
                          md={6}
                          lg={4}
                          key={index}
                          align="center"
                        >
                          <Card
                            sx={{
                              border: "1px solid black",
                            }}
                          >
                            <Box>
                              {order.items.map((item, id) => {
                                return (
                                  <Box key={id} margin="5px">
                                    <Typography>{item.name}</Typography>
                                    <Typography>Price: {item.price}</Typography>
                                    <Typography>
                                      Quantity : {item.quantity}
                                    </Typography>
                                    <Typography>Date : {order.date}</Typography>
                                  </Box>
                                );
                              })}
                            </Box>
                            <Typography variant="h5">
                              Total : {order.total}
                            </Typography>
                            <CardContent
                              sx={{
                                textAlign: "center",
                                border: "0px solid black",
                                height: "10px",
                                background: "#C4C4C4",
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "150%", marginTop: "-10px" }}
                              >
                                {order.amount} {order.currency}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      )}
                    </React.Fragment>
                  );
                })}
              </Grid>
            </TabPanel> */}

            {/* <TabPanel value="1" index={1}>

              <Grid container spacing={2} column={12}>
                {currentUser?.mintData?.map((mint, index) => (
                  <Grid item xs={12} md={6} lg={4} key={index} align="center">
                    <Card
                      sx={{
                        border: "1px solid black",
                      }}
                    >
                      <Box>
                        <Typography>Price: {mint.price}</Typography>
                        <Typography>Quantity : {mint.quantity}</Typography>
                      </Box>
                      <Typography variant="h6">
                        Date : {mint.mintDate}
                      </Typography>
                      <Typography
                        sx={{ fontSize: { md: "0.73rem", xs: "0.6rem" } }}
                      >
                        Ref: {mint.hashCode}
                      </Typography>

                      <CardContent
                        sx={{
                          textAlign: "center",
                          border: "0px solid black",
                          height: "10px",
                          background: "#C4C4C4",
                        }}
                      >
                        <Typography
                          sx={{ fontSize: "150%", marginTop: "-10px" }}
                        >
                          Mint Data
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </TabPanel> */}
          </TabContext>
        </Box>
      </ContentContainer>
    </>
  );
};

ProfilePage.defaultProps = {
  title: "Print tee",
  username: "User Name",
  description: "Description",
  joinedDate: "Joined On Date",
};

export default ProfilePage;
